/**
 * App Settings API client.
 *
 * The settings store is a key/value table used by runtime-configurable
 * features such as the Support Contact widget and the in-app Help page.
 * Keys are immutable (managed via Alembic migrations); only values are
 * mutable, and only by superAdmin users.
 */

import { api } from './client';

export interface AppSetting {
  settingKey: string;
  settingValue: string | null;
  description: string | null;
  category: string | null;
  sortOrder: number;
  modifiedAt: string | null;
}

export const appSettingsApi = {
  /** List every setting. Available to any authenticated user. */
  list: async (): Promise<AppSetting[]> => {
    return api.get<AppSetting[]>('/appSettings/');
  },

  /** Fetch a single setting by key. */
  get: async (settingKey: string): Promise<AppSetting> => {
    return api.get<AppSetting>(`/appSettings/${encodeURIComponent(settingKey)}`);
  },

  /** Update a setting's value. SuperAdmin only. */
  update: async (settingKey: string, settingValue: string | null): Promise<AppSetting> => {
    return api.put<AppSetting>(
      `/appSettings/${encodeURIComponent(settingKey)}`,
      { settingValue }
    );
  },
};
